/**
 * Format API / ISO-8601 timestamps for display in the user's local timezone.
 * The backend may store UTC; this is presentation-only.
 */
export function formatLocalDateTime(
  value: string | null | undefined,
  options?: Intl.DateTimeFormatOptions
): string {
  if (value == null || String(value).trim() === "") {
    return "—";
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    return "—";
  }
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    ...options,
  });
}
